<template>
  <div class='container mt-2 basic-info'>
    <div class='col-md'>
      <div class='card'>
        <div class='card-body'>
          <div class='col-md-12'>
            <div class='row'>
              <div class='col-md-6'>
                <h5 class='float-start card-title'>Vehicle Information</h5>
              </div>
              <div class='col-md-6'>
              </div>
            </div>
          </div>
          <div class='col-md-12'>
            <div class='row'>
              <!--              {{ this.vehicleInformation }}-->
              <div class='col-md-4'>
                <span>Garage Location</span>
                <p>{{ this.vehicleInformation.garage_location ? this.vehicleInformation.garage_location : 'N/A' }}</p>

                <span>Vehicle Owner</span>
                <p>{{ this.vehicleInformation.is_owner ? this.vehicleInformation.is_owner : 'N/A' }}</p>

                <span>Route</span>
                <p>{{ this.vehicleInformation.route_name ? this.vehicleInformation.route_name : 'N/A' }}</p>

                <span>No. of Trips</span>
                <p>{{ this.vehicleInformation.total_trips ? this.vehicleInformation.total_trips : 'N/A' }}</p>
              </div>
              <div class='col-md-4'>
                <span>Vehicle Type</span>
                <p>{{ this.vehicleInformation.car_type ? this.vehicleInformation.car_type : 'N/A' }}</p>

                <span>Interested for</span>
                <p>
                  {{ this.vehicleInformation.interest_in_rental_service ? this.vehicleInformation.interest_in_rental_service : 'N/A'
                  }}</p>

                <span>Drop Location</span>
                <p>{{ this.vehicleInformation.drop_location ? this.vehicleInformation.drop_location : 'N/A' }}</p>
              </div>
              <div class='col-md-4'>
                <span>Vehicle Model</span>
                <p>{{ this.vehicleInformation.car_brand ? this.vehicleInformation.car_brand : 'N/A' }}
                  {{ this.vehicleInformation.car_model ? this.vehicleInformation.car_model : 'N/A' }}</p>

                <span>Interested in Ride Sharing</span>
                <p>{{ this.vehicleInformation.is_ride_sharing_service_included ? this.vehicleInformation.is_ride_sharing_service_included :'N/A' }}</p>

                <span>Weekly Duties</span>
                <p>{{ this.vehicleInformation.weekly_duties ? this.vehicleInformation.weekly_duties : 'N/A' }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../config/axios';

export default {
  name: 'VehicleInformation',
  data() {
    return {
      vehicleInformation: {}
    };
  },
  mounted() {
    this.getVehicleInformation();
  },
  methods: {
    getVehicleInformation() {
      http.get('v3/partners/' + `${this.$route.params.id}` + '/vehicles')
        .then((response) => {
          // console.log('response ===',response.data.data);
          this.vehicleInformation.length = 0;
          this.vehicleInformation = response.data.data.vehicleInfo;
        })
        .catch(err => {
          // this.errorMessage = error.message;
          console.error('There was an error!', err);
        });
    }
  }
  // unmounted() {
  //   this.$emit('passvehicleinfo', this.vehicleInformation);
  // }
};
</script>

<style scoped>
.basic-info h5 {
  font-size: 18px;
  font-family: Montserrat;
  Line-height: 14px;
  font-style: normal;
  font-weight: 600;

}

.basic-info span {
  font-size: 14px;
  font-family: Montserrat;
  font-weight: bold;
  text-decoration: none;
  line-height: normal;
}

.basic-info p {
  font-size: 12px;
  font-family: Montserrat;
}
</style>